import React from "react"
import { useIntl } from "react-intl"
import {
	DataTableCellAlphaNumeric,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import { formatNumber } from "helpers/numbers"
import { ROW_CLASSNAME } from "../constants"
import { getCssForValue } from "../utils"
import { SwitchingBenchmarkRowTableProps } from "../interfaces"
import "./SwitchingBenchmarkRowTable.scss"
import { BenchmarkDetail } from "../../interfaces"

const SwitchingBenchmarkRowTable: React.FC<SwitchingBenchmarkRowTableProps> = (
	props
) => {
	const { data } = props
	const intl = useIntl()

	return (
		<>
			{data.map((row: BenchmarkDetail, key: number) => {
				return (
					<DataTableRow key={key} className="benchmark-row">
						<DataTableCellAlphaNumeric>{row.name}</DataTableCellAlphaNumeric>
						<DataTableCellAlphaNumeric UNSAFE_className={ROW_CLASSNAME}>
							{formatNumber(row.profits, intl)}
						</DataTableCellAlphaNumeric>
						<DataTableCellAlphaNumeric UNSAFE_className={ROW_CLASSNAME}>
							{formatNumber(row.losses * -1, intl)}
						</DataTableCellAlphaNumeric>
						<DataTableCellAlphaNumeric UNSAFE_className={ROW_CLASSNAME}>
							<p
								data-testid="total-difference"
								className={`${getCssForValue(row.difference)}`}
							>
								{formatNumber(row.difference, intl)}
							</p>
						</DataTableCellAlphaNumeric>
					</DataTableRow>
				)
			})}
		</>
	)
}

export default SwitchingBenchmarkRowTable
